import { render, staticRenderFns } from "./transferDetailDialog.vue?vue&type=template&id=4bdc5d9c&scoped=true"
import script from "./transferDetailDialog.vue?vue&type=script&lang=js"
export * from "./transferDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./transferDetailDialog.vue?vue&type=style&index=0&id=4bdc5d9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdc5d9c",
  null
  
)

export default component.exports